const actionTypes = { SET_PHOTO_CAPTURE_SMART_SKIN_SCAN_CONTENT: 'SET_PHOTO_CAPTURE_SMART_SKIN_SCAN_CONTENT' };

module.exports = actionTypes;
